"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTouchFree64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M.5.5h64v64H.5z" }), (0, jsx_runtime_1.jsx)("path", { d: "M41.925 50.69A36.214 36.214 0 0 0 46.8 32.5a36.214 36.214 0 0 0-4.875-18.19M17.519 38.158A9.057 9.057 0 0 0 19.5 32.5c0-2.055-.698-4.05-1.98-5.655m8.168 15.508A18.101 18.101 0 0 0 28.6 32.5a18.101 18.101 0 0 0-2.912-9.853m8.107 23.87A27.134 27.134 0 0 0 37.7 32.5a27.134 27.134 0 0 0-3.905-14.017", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgTouchFree64;
